// eslint-disable-next-line import/prefer-default-export
export const TOTAL_CLIENTS = 250;
